import { memo } from 'react';
import { Tooltip } from 'antd';
import CollectAction from '@/components/collect-action';
import { FullScreen, ExitFullScreen } from '@/components/svg-icons/navigation-bar';
import Markdown from '@/components/markdown';
import { useGlobalStore } from '@/store/global';
import { CloseOutlined } from '@ant-design/icons';
import { useIsFullScreen } from '@/components/drag-drawer/index.helper';
import queryDomMethods from '@/utils/query-dom-methods';
import './knowledge-points-content.scss';

interface IProps {
    title: string;
    content: string;
    collectRecordId?: string;
    onClose: () => void;
}

const KnowledgePointsContent = ({ collectRecordId, title, content, onClose }: IProps) => {
    const { setDragDrawerWidthForMax, setDragDrawerWidthForMin } = useGlobalStore();
    const isFullScreen = useIsFullScreen();

    return (
        <div className="knowledge-points-drawer__container">
            <div className="knowledge-points-drawer__header">
                <div className="knowledge-points-drawer__header-title">知识切片</div>
                {collectRecordId && <CollectAction recordId={collectRecordId} needToastInQa />}
                <Tooltip
                    title={isFullScreen ? '退出全屏' : '全屏'}
                    placement="bottomRight"
                    arrow={{ pointAtCenter: true }}
                    getPopupContainer={queryDomMethods.queryLucaQaRoot}
                    autoAdjustOverflow={false}
                >
                    <div className="navigation-bar__size-control">
                        {isFullScreen ? (
                            <ExitFullScreen onClick={setDragDrawerWidthForMin} />
                        ) : (
                            <FullScreen onClick={setDragDrawerWidthForMax} />
                        )}
                    </div>
                </Tooltip>
                <div className="knowledge-points-drawer__close-container" onClick={onClose}>
                    <CloseOutlined className="knowledge-points-drawer__close" />
                </div>
            </div>
            <div className="knowledge-points-drawer__content-scroll-container">
                <div className="knowledge-points-drawer__content">
                    <div className="knowledge-points-drawer__title">{title}</div>
                    <div className="knowledge-points-drawer__markdown-container">
                        <Markdown content={content} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(KnowledgePointsContent);
